import {
  PaymentMethodProps,
  PaymentTypeEnum,
} from 'modules/payment-methods/types';
import paymentMethodsKeys from 'modules/payment-methods/util/payment-methods-keys';
import React from 'react';
import List from 'shared/layout/list';
import ApiSwitch from 'shared/migration-components/api-switch';
import useProjection from 'shared/migration-hooks/use-projection';

const PaymentMethods: React.FC = () => {
  const projection = useProjection<PaymentMethodProps>('paymentMethods', [
    'id',
    'name',
    'type',
    'active',
  ]);

  return (
    <List<PaymentMethodProps>
      {...{
        titleBar: {
          title: 'Formas de pagamento',
          actionButton: {title: 'NOVA FORMA DE PAGAMENTO', to: 'create'},
        },
        table: {
          url: '/payment-methods',
          projection: {
            ...projection,
            options: [
              'name',
              {
                value: 'type',
                column: (row) =>
                  row.type === PaymentTypeEnum.IN_PERSON
                    ? 'Na entrega'
                    : 'Online',
                filter: {
                  type: 'select',
                  values: [
                    {
                      label: 'Na entrega',
                      value: PaymentTypeEnum.IN_PERSON,
                    },
                    {
                      label: 'Online',
                      value: PaymentTypeEnum.ONLINE,
                    },
                  ],
                },
              },
              {
                value: 'active',
                column: {
                  value: (row) => (
                    <ApiSwitch
                      isChecked={row.active}
                      url={`/payment-methods/${row.id}`}
                      queryKey={paymentMethodsKeys.list()}
                    />
                  ),
                  stopPropagation: true,
                },
                filter: {
                  type: 'select',
                  values: [
                    {
                      label: 'Sim',
                      value: true,
                    },
                    {
                      label: 'Não',
                      value: false,
                    },
                  ],
                },
              },
            ],
          },
          translatedPropsKey: 'PaymentMethodProps',
        },
        queryKey: paymentMethodsKeys.list(),
      }}
    />
  );
};

export default PaymentMethods;
